module.exports = __webpack_public_path__ + "img/spinner-03(Small).7e83dff5.png";